import * as Models from '../../../Models'
import * as UserManagementApiClient from './UserManagementApiClientService'

export interface IGroupRetrievalService {
  getAllGroupSummaries(): ng.IPromise<Models.GroupModel.IGroupSummaryModel[]>;
  getGroupsInPartner(partnerCode: string): ng.IPromise<Models.GroupModel.IGroupModel[]>;
  getGroupById(id: string): ng.IPromise<Models.GroupModel.IGroupModel>;
  getGroupTypes(): ng.IPromise<Models.GroupTypeModel.IGroupTypeModel[]>;
}

export class GroupRetrievalService implements IGroupRetrievalService {
  public static $inject = ["UserManagementApiClientService"];

  constructor(private userManagementApiClientService: UserManagementApiClient.IUserManagementApiClientService) {}

  public getAllGroupSummaries = () => {
    return this.userManagementApiClientService.getAllGroupSummaries();
  };

  public getGroupsInPartner = (partnerCode: string) => {
    return this.userManagementApiClientService.getGroupsInPartner(partnerCode);
  };

  public getGroupById = (id: string) => {
    return this.userManagementApiClientService.getGroupById(id);
  };

  public getGroupTypes = () => {
    return this.userManagementApiClientService.getGroupTypes();
  }
}
